import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "trigger"]

  open() {
    if (this.dialogTarget.open) return
    this.dialogTarget.querySelectorAll("details[open]").forEach(row => row.removeAttribute("open"))
    this.previousOverflow = document.body.style.overflow
    this.dialogTarget.showModal()
    this.dialogTarget.scrollTop = 0
    document.body.style.overflow = "hidden"
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
    this.restore()
  }

  restore() {
    if (this.hasDialogTarget && this.dialogTarget.open) return
    if (this.previousOverflow === undefined) return
    document.body.style.overflow = this.previousOverflow
    this.previousOverflow = undefined
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false")
      if (this.triggerTarget.isConnected) this.triggerTarget.focus()
    }
  }

  cancel(event) {
    event.preventDefault()
    this.close()
  }

  trapFocus(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
      return
    }
    if (event.key !== "Tab") return
    const controls = [...this.dialogTarget.querySelectorAll("button, summary, a[href], input, select, textarea, [tabindex='0']")]
      .filter(element => !element.disabled && element.getClientRects().length)
    const first = controls[0], last = controls[controls.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  backdropClose(event) {
    if (event.target !== this.dialogTarget) return
    const rect = this.dialogTarget.getBoundingClientRect()
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close()
  }

  disconnect() {
    this.close()
  }
}
